import _ from 'lodash'

export default {
  state: {
    msgNum: 0,
    activeNum: 1
  },
  getters: {
  },
  actions: {
  },
  mutations: {
    changeState(state, value) {
      state.msgNum = value;
      console.log(state.msgNum)
    },
    changeActive(state, value) {
      state.activeNum = value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/msg.js